import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { APP_ROUTES } from "../utils/constants"
import authService from "../services/authService"
import { useAuth } from "../lib/useAuth"
import Navbar from "./Navbar"
import Sidebar from "./Sidebar"

const ProtectedRoute = ({
    children,

    fallbackPath = APP_ROUTES.SIGN_IN,
}) => {
    const location = useLocation()
    const { user, isAuthenticated, loading } = useAuth()

    // Check if user is authenticated
    if ((!isAuthenticated || !authService.isTokenValid()) && !loading) {
        // Redirect to login with return path
        return <Navigate to={fallbackPath} state={{ from: location }} replace />
    }

    // If all checks pass, render the protected component
    return (
        <>
            <Navbar />
            <Sidebar />
            {children}
        </>
    )
}

export default ProtectedRoute
